import type { ApolloClient } from "@apollo/client";
import { createContext, type ReactNode, useContext, useMemo } from "react";
import { useAuth } from "src/features/auth/AuthProvider";
import { createArcApolloClient } from "src/gql/createArcApolloClient";
import { useArcToken } from "../ArcTokenProvider/context";

const ArcApolloContext = createContext<ApolloClient | null>(null);

export function useArcApolloClient(): ApolloClient {
  const client = useContext(ArcApolloContext);
  if (!client) {
    throw new Error("useArcApolloClient must be used within ArcApolloProvider");
  }
  return client;
}

export function ArcApolloProvider({ children }: { children: ReactNode }) {
  const { ensureToken, refreshToken } = useArcToken();
  const { markIpRestricted } = useAuth();

  const client = useMemo(() => {
    return createArcApolloClient({
      ensureToken,
      refreshToken,
      onIpRestricted: markIpRestricted,
    });
  }, [ensureToken, refreshToken, markIpRestricted]);

  return (
    <ArcApolloContext.Provider value={client}>
      {children}
    </ArcApolloContext.Provider>
  );
}
